import React from 'react'
import styled from 'styled-components'
import Amount from '../Amount'
import { FormattedMessage } from 'react-intl'
import { calculateRate } from '../../types/Fees'
import TaxRow from '../TaxRates/TaxRow'
import { DiscountOrTax } from '../../types'

const TotalRow = styled.div`
  display: flex;
  align-items: center;
`

const TotalName = styled.div`
  padding-left: 8px;
  flex: 111;
`

const TotalAmount = styled.div`
  padding-left: 8px;
  flex: 212;
`

type Props = {
  discount?: DiscountOrTax
  tax?: DiscountOrTax
  total?: number
  unit?: string
  taxRow?: React.ReactNode
}

const TotalBlock = ({ discount, tax, total, unit, taxRow }: Props) => {
  const discountedAmount =
    !!discount && !!total ? total - calculateRate(discount.rate, total) : total
  const finalAmount =
    !!tax && !!discountedAmount
      ? discountedAmount + calculateRate(tax.rate, discountedAmount)
      : discountedAmount

  return (
    <div>
      <TotalRow>
        <TotalName>
          <FormattedMessage id="subTotal" />
        </TotalName>
        <TotalAmount>
          {!!discountedAmount && !!unit ? (
            <Amount amount={discountedAmount} unit={unit} />
          ) : (
            <FormattedMessage id="notApplicable" />
          )}
        </TotalAmount>
      </TotalRow>
      {taxRow ??
        (!!tax ? (
          <TaxRow {...tax} total={discountedAmount} unit={unit} />
        ) : null)}
      <TotalRow>
        <TotalName>
          <FormattedMessage id="total" />
        </TotalName>
        <TotalAmount>
          {!!finalAmount && !!unit ? (
            <Amount amount={finalAmount} unit={unit} />
          ) : (
            <FormattedMessage id="notApplicable" />
          )}
        </TotalAmount>
      </TotalRow>
    </div>
  )
}

export default TotalBlock
